import { paginationFiltersSchema } from 'utils/schemas';
import { z } from 'zod';
import { reactionsVariants } from './reactions.types';

export const reactionsFiltersSchema = z
  .object({
    reaction: z.enum(reactionsVariants).nullable().catch(null),
  })
  .merge(paginationFiltersSchema);
